<div class="d-flex w-100 justify-content-center">
  <div i18n="@@collection.config.tab.automations.empty">
    There are no automations yet. Create some by clicking on the button below!
  </div>
</div>
